export const backgroundColorVariants = {
  'bg-color': {
    primary: 'bg-bg-primary',
    'primary-disabled': 'bg-bg-primary-disabled',
    'primary-hover': 'bg-bg-primary-hover',
    'primary-selected': 'bg-bg-primary-selected',
    'primary-error': 'bg-bg-primary-error',
    'primary-core': 'bg-bg-primary-core',
    'primary-luxe': 'bg-bg-primary-luxe',
    'primary-plus': 'bg-bg-primary-plus',
    'primary-inverse': 'bg-bg-primary-inverse',
    'primary-inverse-hover': 'bg-bg-primary-inverse-hover',
    'primary-inverse-disabled': 'bg-bg-primary-inverse-disabled',
    'primary-inverse-error': 'bg-bg-primary-inverse-error',
    'primary-inverse-error-hover': 'bg-bg-primary-inverse-error-hover',

    secondary: 'bg-bg-secondary',
    'secondary-core': 'bg-bg-secondary-core',
    'secondary-core-rtl': 'bg-bg-secondary-core-rtl',
    'secondary-core-hover': 'bg-bg-secondary-core-hover',
    'secondary-plus': 'bg-bg-secondary-plus',
    'secondary-plus-rtl': 'bg-bg-secondary-plus-rtl',
    'secondary-plus-hover': 'bg-bg-secondary-plus-hover',
    'secondary-luxe': 'bg-bg-secondary-luxe',
    'secondary-luxe-rtl': 'bg-bg-secondary-luxe-rtl',
    'secondary-luxe-hover': 'bg-bg-secondary-luxe-hover',
    'secondary-plus-luxe': 'bg-bg-secondary-plus-luxe',
    'secondary-plus-luxe-rtl': 'bg-bg-secondary-plus-luxe-rtl',
    'secondary-plus-luxe-hover': 'bg-bg-secondary-plus-luxe-hover',

    tertiary: 'bg-bg-tertiary',
    'tertiary-hover': 'bg-bg-tertiary-hover',
    'tertiary-selected': 'bg-bg-tertiary-selected',
    'tertiary-disabled': 'bg-bg-tertiary-disabled',
    'tertiary-core': 'bg-bg-tertiary-core',

    quaternary: 'bg-bg-quaternary',
    'quaternary-hover': 'bg-bg-quaternary-hover',

    white: 'bg-white',
    black: 'bg-black',
    transparent: 'bg-transparent',
    deco: 'bg-deco',

    warning: 'bg-orange-200',
    danger: 'bg-red-200',
    success: 'bg-green-200',
    info: 'bg-blue-200',
  },
}
